import { createContext, useContext, useEffect } from "react";

// Theme switching removed — the app is dark-mode only.
// This file remains as a thin shim so existing imports don't break.
const ThemeContext = createContext({ theme: "dark", setTheme: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.dataset.theme = "dark";
    // Clean up any stale light/auto preference so users on old builds
    // don't stay stuck in a half-broken light state.
    try { localStorage.removeItem("ica_theme"); } catch {}
  }, []);
  return (
    <ThemeContext.Provider value={{ theme: "dark", setTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
